type ModifierDataLike<TModifier, TSelections> = {
  modifier: TModifier;
  selections: TSelections;
};

type ModifierGroupLike<TModifier, TSelections> = {
  modifiers: ModifierDataLike<TModifier, TSelections>[];
};

export function stabilizeModifierGroupSelections<
  TGroup extends ModifierGroupLike<TModifier, TSelections>,
  TModifier,
  TSelections
>(
  groups: TGroup[],
  cache: Map<string, TSelections>,
  getModifierKey: (modifier: TModifier) => string,
  areSelectionsEqual: (previous: TSelections, next: TSelections) => boolean
): TGroup[] {
  return groups.map(group => ({
    ...group,
    modifiers: group.modifiers.map(modifierData => {
      const modifierKey = getModifierKey(modifierData.modifier);
      const cachedSelections = cache.get(modifierKey);
      const nextSelections = modifierData.selections;

      if (cachedSelections && areSelectionsEqual(cachedSelections, nextSelections)) {
        return {
          modifier: modifierData.modifier,
          selections: cachedSelections,
        };
      }

      cache.set(modifierKey, nextSelections);

      return modifierData;
    }),
  }));
}

export function areNumericRecordSelectionsEqual(
  previous: Record<string, number>,
  next: Record<string, number>
): boolean {
  const previousKeys = Object.keys(previous);
  const nextKeys = Object.keys(next);

  if (previousKeys.length !== nextKeys.length) {
    return false;
  }

  for (const key of previousKeys) {
    if (previous[key] !== next[key]) {
      return false;
    }
  }

  return true;
}
